export const GalleriaService = {
  getData() {
    return [
      {
        itemImageSrc: "./images/galleria/g1.png",
        thumbnailImageSrc:
          "https://primefaces.org/cdn/primereact/images/galleria/galleria4s.jpg",
        alt: "Description for Image 4",
        title: "Title 4",
      },

      {
        itemImageSrc: "./images/galleria/g2.jpg",
        thumbnailImageSrc:
          "https://primefaces.org/cdn/primereact/images/galleria/galleria7s.jpg",
        alt: "Description for Image 7",
        title: "Title 7",
      },

      {
        itemImageSrc: "./images/galleria/g3.jpg",
        thumbnailImageSrc:
          "https://primefaces.org/cdn/primereact/images/galleria/galleria9s.jpg",
        alt: "Description for Image 9",
        title: "Title 9",
      },

      {
        itemImageSrc: "./images/galleria/g4.jpg",
        thumbnailImageSrc:
          "https://primefaces.org/cdn/primereact/images/galleria/galleria13s.jpg",
        alt: "Description for Image 13",
        title: "Title 13",
      },

      {
        itemImageSrc: "./images/galleria/g5.jpg",
        thumbnailImageSrc:
          "https://primefaces.org/cdn/primereact/images/galleria/galleria15s.jpg",
        alt: "Description for Image 15",
        title: "Title 15",
      },
    ];
  },

  getImages() {
    return Promise.resolve(this.getData());
  },
};
